package org.hs_soft.runmynesto.pages.home.sub_page.dashboard.component.dashboard_reports.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.overflowY
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.thenIf
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.autoResponsiveness
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.dashboard.PaymentType
import org.hs_soft.runmynesto.domain.model.home.dashboard.dashboard_config.ListShopItem
import org.hs_soft.runmynesto.domain.model.home.dashboard.get_shop_statics.ShopStatistic
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.flexGrow
import org.jetbrains.compose.web.css.px

@Composable
fun DashboardReports(
    modifier: Modifier=Modifier,
    windowSizeMode: WindowSizeModeEnum,
    loading:Boolean,
    shopStaticsData: List<ShopStatistic>?,
    listShop: List<ListShopItem?>?,
    currencyType: String,
    onItemClick: (ShopStatistic, String) -> Unit,
)
{
    val chunk=when(windowSizeMode){
        WindowSizeModeEnum.Desktop -> 5
        WindowSizeModeEnum.TABLET -> 2
        WindowSizeModeEnum.PHONE -> 1
    }

    Column(
        modifier = modifier
            .fillMaxWidth()
            .overflow(Overflow.Auto)
            .height(0.px)
            .margin(top = Dimen.extraLargePadding2)
            .styleModifier {
                flexGrow(1)
                overflowY(Overflow.Auto)
                display(DisplayStyle.Flex)
            }
        ,
        horizontalAlignment = if (windowSizeMode== WindowSizeModeEnum.PHONE)
            Alignment.CenterHorizontally else Alignment.Start
    )
    {
        InfoDetail(
            shopStaticsData=shopStaticsData,
            chunk=chunk,
            loading=loading,
            windowSizeMode=windowSizeMode,
            listShop=listShop,
            currencyType=currencyType,
            onItemClick = { item:ShopStatistic,name:String->
                onItemClick(
                    item,name
                )
            }
        )
    }




}


@Composable
private fun InfoDetail(
    shopStaticsData: List<ShopStatistic>?,
    chunk: Int,
    loading:Boolean,
    windowSizeMode: WindowSizeModeEnum,
    listShop: List<ListShopItem?>?,
    currencyType: String,
    onItemClick: (ShopStatistic, String) -> Unit
) {
    if (shopStaticsData != null) {
        shopStaticsData.chunked(chunk).forEach { rowItems ->
            Row(
                modifier = Modifier
                    .thenIf(
                        windowSizeMode == WindowSizeModeEnum.PHONE,
                        Modifier.fillMaxWidth()
                    )
            ) {
                rowItems.forEach { model ->
                    val cashTotal = model.statData?.operations?.filter {
                        it.type.toString() == PaymentType.CASH.code
                    }?.sumOf { it.total ?: 0.0 } ?: 0.0

                    val eftTotal = model.statData?.operations?.filter {
                        it.type.toString() == PaymentType.EFT.code
                    }?.sumOf { it.total ?: 0.0 } ?: 0.0

                    val creditTotal = model.statData?.operations?.filter {
                        it.type.toString() in PaymentType.ALL_CREDIT_TYPES
                    }?.sumOf { it.total ?: 0.0 } ?: 0.0

                    val tipsTotal = model.statData?.operations?.filter {
                        it.type.toString() == PaymentType.TIPS.code
                    }?.sumOf { it.total ?: 0.0 } ?: 0.0

                    val cancelledTotal = model.statData?.operations?.filter {
                        it.type.toString() == PaymentType.REMOVED.code
                    }?.sumOf { it.total ?: 0.0 } ?: 0.0

                    val operationsCount = model.statData?.operations?.size ?: 1
                    val totalRevenue = model.statData?.totalRevenue ?: 0.0
                    val revenuePerOperation = if (operationsCount > 0) totalRevenue / operationsCount else 0.0


                    if (cashTotal==0.0 && eftTotal==0.0
                        && creditTotal==0.0 && tipsTotal==0.0
                        && cancelledTotal==0.0 && revenuePerOperation==0.0
                    ){
                        EmptyDashboardReportItem(
                            windowSizeMode=windowSizeMode,
                            title= listShop?.find {
                                it?.id == model.branchId.toString()
                            }?.name,
                        )
                    }else{
                        DashboardReportItem(
                            model = model,
                            cashTotal=cashTotal,
                            eftTotal=eftTotal,
                            creditTotal=creditTotal,
                            tipsTotal=tipsTotal,
                            cancelledTotal=cancelledTotal,
                            revenuePerOperation=revenuePerOperation,
                            name = listShop?.find {
                                it?.id == model.branchId.toString()
                            }?.name,
                            windowSizeMode = windowSizeMode,
                            currencyType = currencyType,
                            onItemClick = {
                                onItemClick(
                                    model,
                                    listShop?.find {
                                        it?.id == model.branchId.toString()
                                    }?.name ?: ""
                                )
                            }
                        )
                    }

                }
            }
        }
    }
    else if ( loading){
        val placeholderItems = List(10) { index -> index }
        placeholderItems.chunked(chunk).forEach { rowItems ->
            Row(
                modifier = Modifier
                    .thenIf(
                        windowSizeMode == WindowSizeModeEnum.PHONE,
                        Modifier.fillMaxWidth()
                    )
            ) {
                rowItems.forEach { _ ->

                    EmptyDashboardReportItem(
                        windowSizeMode = windowSizeMode,
                        title = Strings.current().shopName
                    )
                }
            }
        }
    }
}
